import React from "react";
import { Overline } from "@/components/Reveal";
import { useLang } from "@/context/LanguageContext";
import { VENUES } from "@/data/content";

export const VenueMarquee = () => {
  const { t } = useLang();
  const items = [...VENUES, ...VENUES];
  return (
    <section data-testid="venues-section" className="py-16 md:py-20 bg-[#0A1128] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 text-center mb-10">
        <Overline className="text-[#C5A880]">{t.venues.overline}</Overline>
        <h2 className="font-display text-2xl sm:text-3xl font-light text-[#FAF9F6] mt-4">{t.venues.title}</h2>
      </div>
      <div className="relative">
        <div className="flex gap-16 md:gap-24 w-max animate-marquee">
          {items.map((v, i) => (
            <span
              key={i}
              className="font-display text-2xl md:text-3xl tracking-[0.15em] uppercase text-[#FAF9F6]/55 whitespace-nowrap"
            >
              {v}
            </span>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0A1128] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0A1128] to-transparent" />
      </div>
    </section>
  );
};
